exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resized-image__resized-image__3OS6E{background-size:cover;background-position:50%;background-repeat:no-repeat}", ""]);

// exports
exports.locals = {
	"resized-image": "resized-image__resized-image__3OS6E",
	"resizedImage": "resized-image__resized-image__3OS6E"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/shared/components/resized-image/resized-image.styl
// module id = 963
// module chunks = 0 1 2 3 4